export const languagesData = {
  English: 80,
  "Japanese(N3)": 60,
  Hindi: 80,
  Marathi: 90,
};
